module.exports = __webpack_public_path__ + "img/horizontal_4_7_1.2f618a2c.png";